import React, { useEffect, useState } from 'react';
import './SearchFeedback.css';

function SearchFeedback({ isSearching, stage, resultCount, hasResults, hasSearched, searchTitle }) {
  const [messageKey, setMessageKey] = useState(0);

  useEffect(() => {
    setMessageKey(prev => prev + 1);
  }, [stage]);

  const getMessage = () => {
    if (!hasSearched) {
      return '';
    }
    
    if (isSearching) {
      const titleDisplay = searchTitle ? ` - "${searchTitle.substring(0, 40)}${searchTitle.length > 40 ? '...' : ''}"` : '';
      
      switch (stage) {
        case 'starting-search':
          return `Searching${titleDisplay}...`;
        case 'first-results':
          return `${resultCount} results found${titleDisplay}...`;
        case 'geolocation-found':
          return `Location found${titleDisplay}...`;
        case 'investigation-complete':
          return `Network information gathered${titleDisplay}...`;
        case 'direct-matches':
          return `${resultCount} results found${titleDisplay}...`;
        case 'nearby-matches':
          return `${resultCount} results nearby${titleDisplay}...`;
        case 'ranked':
          return `${resultCount} results sorting${titleDisplay}...`;
        case 'expanding-search':
          return `Extended search running${titleDisplay}...`;
        case 'social-media-found':
          return `Profiles found in social media${titleDisplay}...`;
        case 'social-media-search':
          return `Searching social platforms for geo matches${titleDisplay}...`;
        case 'progressive-batch':
          return `${resultCount} results${titleDisplay}...`;
        case 'started':
          return `Searching${titleDisplay}...`;
        default:
          return `Searching${titleDisplay}...`;
      }
    } else if (hasResults === true && resultCount > 0) {
      return `${resultCount} result${resultCount !== 1 ? 's' : ''} for "${searchTitle}"`;
    } else if (hasResults === false) {
      return `No results for "${searchTitle}"`;
    }
    return '';
  };

  return (
    <>
      {isSearching && <div className="search-particles" aria-hidden="true" />}
      <div
        key={messageKey}
        className={`search-feedback ${isSearching ? 'search-feedback-active' : ''} ${hasResults === true ? 'search-feedback-success' : hasResults === false ? 'search-feedback-empty' : ''}`}
        aria-live="polite"
        aria-atomic="true"
      >
        <span className="search-feedback-message">{getMessage()}</span>
      </div>
    </>
  );
}

export default SearchFeedback;
